<template>
    <div class="index-main">
        <header-bar tab-index="6"/>

        <div class="contact-container">
            <div class="mes-header">
                <img src="../../resource/img/contact.jpg" style="width: 100%;"/>
                <div class="mes-title">联系我们</div>
            </div>

            <div class="contact-body">
                <div class="index-container" style="display: flex;flex-direction: column;align-items: center">
                    <div style="font-size: 48px;color: #0171cb;font-weight: bold;">大连沣同科技有限公司</div>
                    <div style="margin-top: 10px;font-size: 27px;color: #191919;">国内领先的制造企业数字化解决方案提供商</div>
                    <div style="margin-top: 30px;display: flex;align-items: center">
                        <div>
                            <div class="contact-item">
                                <div><i class="fa fa-map-marker fa-fw"></i>地　址：</div>
                                <div>辽宁省大连市高新园区火炬路38号三丰大厦C座2102室</div>
                            </div>
                            <div class="contact-item">
                                <div><i class="fa fa-user fa-fw"></i>联系人：</div>
                                <div>王经理 150 4119 0343（微信同）</div>
                            </div>
                            <div class="contact-item">
                                <div><i class="fa fa-user fa-fw"></i>联系人：</div>
                                <div>姜经理 132 5297 7725（微信同）</div>
                            </div>
                        </div>
                        <div style="display: flex;flex-direction: column;align-items: center;font-size: 18px;margin-left: 80px;">
                            <img src="../../resource/img/qrcode.png" style="width: 200px;"/>
                            <div style="margin: 15px 0;">抖音号</div>
                            <div>@沣同科技数字工厂服务商</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <side-bar/>
        <footer-bar/>
    </div>
</template>

<script>
import HeaderBar from "../../components/header";
import FooterBar from "../../components/footer";
import SideBar from "../../components/sider";
import '../../resource/css/common.css';

export default {
    name: "aboutIndex",
    components: {
        'header-bar': HeaderBar,
        'footer-bar': FooterBar,
        'side-bar': SideBar,
    },
}
</script>

<style scoped>
    .contact-body {
        padding: 30px;
    }

    .contact-item {
        display: flex;
        align-items: center;
        font-size: 22px;
        margin: 20px 0;
    }

    .contact-item i {
        margin-right: 10px;
    }
</style>
